<template>
  <router-view />
</template>

<script>
export default {
  name: 'AddressBookActionLayout'
}
</script>

<style scoped>
</style>
